/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_CommuteInputs */

const en_homepage_listen_in_commute = /** @type {(inputs: Homepage_Listen_In_CommuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Your Commute`)
};

const es_homepage_listen_in_commute = /** @type {(inputs: Homepage_Listen_In_CommuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De camino al trabajo`)
};

/**
* | output |
* | --- |
* | "On Your Commute" |
*
* @param {Homepage_Listen_In_CommuteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_commute = /** @type {((inputs?: Homepage_Listen_In_CommuteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_CommuteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_commute(inputs)
	return en_homepage_listen_in_commute(inputs)
});